import { useEffect, useState } from 'react';

import { useEnvironmentVariables } from '~/hooks/useEnvironmentVariables';
import { tokenManager } from '~/services/TokenManager';
import { createLogger } from '~/utils/logging';

const log = createLogger('useTokenInitialization');

export function useTokenInitialization(): { isInitialized: boolean } {
  const { socraitApiUrl } = useEnvironmentVariables();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    async function init() {
      log.debug('Initializing TokenManager');
      tokenManager.initialize(socraitApiUrl);
      await tokenManager.tryRestoreSession();
      setIsInitialized(true);
      log.info('TokenManager initialized');
    }
    init();
  }, [socraitApiUrl]);

  return { isInitialized };
}
